import React, {useState, useEffect, useRef, useCallback} from "react";
import {useSelector, useDispatch} from "react-redux";
import {Tab, Tabs, TabList, TabPanel} from "react-tabs";
import {
    removeTab,
    reOrderTabs,
    tabActivity,
    tabIncremental,
    tabScrollPosition,
    updateActiveMainTab
} from "../../../_reducers/TabsSlice";
import "./index.scss";
import {Button, Modal} from "react-bootstrap";
import checkViewFunc, {getURLParams} from "../../../_helpers/helperFunctions";
import {
    newBankAccountInitialValue, newCashRegistersInitialValue, newPOSInitialValue,
    setNewBankAccount,
    setNewCashRegisters,
    setNewPOS
} from "../../../_reducers/DataPanel/Cash/cashSlice";
import {
    clientMovementsInitialValues,
    newClientInitialValue,
    resetNewClientPayment, setClientPaymentsSearch,
    setNewClient,
    setNewClientMovements,
    setSearchClientMovements,
    setSearchClients
} from "../../../_reducers/DataPanel/Clients/clientSlice";
import {
    clearNewAdvancedType,
    clearNewBasicType,
    setSearchAdvancedTypes,
    setSearchBasicTypes
} from "../../../_reducers/settingsSlice";
import {
    resetNewPriceList,
    resetNewProductMovements,
    resetProductMovementsNewProduct,
    resetSelectedProduct,
    setSearchProductMovements,
    setSearchProductPriceList,
    setSearchProducts
} from "../../../_reducers/DataPanel/Products/productsSlice";
import {
    setIsEmronConnectFileERP,
    setRememberInnerTabsForce,
    setSaveAdvancedType,
    setSaveBasicType,
    setSaveBuys,
    setSaveClientPayments, setSaveEditQuotations,
    setSaveNewAccountingAccount, setSaveNewAccountingRecord,
    setSaveNewBankAccounts,
    setSaveNewCashRegister,
    setSaveNewClient,
    setSaveNewClientMovements, setSaveNewEmployee, setSaveNewFixedAsset, setSaveNewFixedAssetMovement,
    setSaveNewFixedAssetRecord,
    setSaveNewPOS,
    setSaveNewPriceList,
    setSaveNewProduct,
    setSaveNewProductMovements, setSavePrimerAiUrl, setSaveQuotations,
    setSaveSales,
    setSaveSupplierPayments
} from "../../../_reducers/activitySlice";
import {
    resetNewQuotations,
    resetNewSales,
    setSearchSales,
    setSearchQuotations, resetNewPrimerAiUrl,
} from "../../../_reducers/DataPanel/Sales/salesSlice";
import {resetNewBuys, setSearchBuys} from "../../../_reducers/DataPanel/Buys/buysSlice";
import {
    newEmployeeInitialValue,
    resetNewAccountingAccount,
    resetNewAccountingRecord,
    setNewEmployee, setSearchAccountingAccounts, setSearchAccountingRecords
} from "../../../_reducers/DataPanel/Accounting/accountingSlice";
import {resetFilters} from "../../../_reducers/SearchTableSlice";
import {
    setSearchSupplierMovements,
    setSearchSuppliers,
    setSupplierPaymentsSearch
} from "../../../_reducers/DataPanel/Suppliers/supplierSlice";
import {setWorkingProgramOnEmployee} from "../../../_reducers/DataPanel/Payroll/payrollSlice";
import {toast} from "react-toastify";
import {isEmpty} from "../../../_helpers/commonFunctions";
import {setBuyMarkFromCloud, setSaleMarkFromCloud} from "../../../_reducers/cloudSlice";
import {activePath} from "../../../_reducers/Navbar";
import {setShowDclAfterSaleNew, setShowDclPageAfterSaleNew} from "../../../_reducers/DataPanel/Dcl/dclSlice";
import useMediaQuery from "../../../hooks/useMediaQuery";
import {
    resetNewFixedAsset,
    resetNewFixedAssetMovement,
    resetNewFixedAssetRecord, setSearchFixedAssetMovements, setSearchFixedAssetRecords, setSearchFixedAssets
} from "../../../_reducers/DataPanel/FixedAssets/fixedAssetsSlice";
import {
    addTabIfNotExists, CHECK_FOR_ACTIVITY, generateTabKey,
    openCloud,
    openEmployeeView,
    openPrimerPaymentsReport,
    openPrimerProviderContractsReport,
    openStart
} from "../../../_helpers/tabOpeners";
import {useTranslation} from "../../../hooks/useTranslation";

const TabsLayout = ({permissionsData}) => {
    const {t} = useTranslation();
    const containerRefs = useRef({});
    const dispatch = useDispatch();
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const ACTIVE_MAIN_TAB_SLICE = useSelector((state) => state.ACTIVE_MAIN_TAB);
    const rememberInnerTab = useSelector((state) => state.ACTIVITY.rememberInnerTab);

    const activeTab = TABS_DATA[ACTIVE_MAIN_TAB_SLICE] || null;
    const isMobileScreen = useMediaQuery("(max-width: 980px)");

    const isEpay = permissionsData?.some((el) => el.permissionName === "custom-epay" || el.permissionName === "custom-peiraios" || el.permissionName === "custom-daras");
    const isCardlink = permissionsData?.some((el) => el.permissionName === "custom-cardlink");
    const isEmployee = permissionsData?.some((el) => el.permissionName === "custom-employee");
    const isOnlyCloud = permissionsData?.some((el) => el.permissionName === "custom-cloud") && permissionsData.length === 1;
    const isPrimerConstructor = permissionsData?.some((el) => el.permissionName === "custom-primerConstructor");

    const isEmronConnectFileERP = useSelector((state) => state.ACTIVITY.isEmronConnectFileERP);
    const isInCloudTab = activeTab && activeTab?.tabType === "cloud";

    const slideBarToggle = useSelector((state) => isMobileScreen ? false : state.ACTIVITY.slideBarToggle);

    const [updateTabSelection, setUpdateTabSelection] = useState(false);
    const [tabCloseWarning, showTabCloseWarning] = useState(false);
    const [toRemoveTab, setToRemoveTab] = useState({});
    const [draggedTabIndex, setDraggedTabIndex] = useState(null);

    useEffect(() => {
        // For emron connect
        const params = getURLParams();
        const ssKey = params.get("ssKey");
        const forceNewTab = params.get("forceNewTab");
        const extraData = params.get("extraData");
        if (!isEmpty(ssKey) && !isEmpty(forceNewTab)) {
            dispatch(removeTab("start"));
            dispatch(addTabIfNotExists(forceNewTab, generateTabKey(), TABS_DATA));
            window.history.pushState({}, "", window.location.origin);
            dispatch(setIsEmronConnectFileERP(ssKey));
            if (extraData) {
                try {
                    const parseIt = JSON.parse(extraData);
                    if (parseIt.section === "Buys") {
                        dispatch(setBuyMarkFromCloud(parseIt.mark));
                    } else if (parseIt.section === "Sales") {
                        dispatch(setSaleMarkFromCloud(parseIt.mark));
                    }
                } catch {
                    toast.error("Σφάλμα κατά την αντιστοίχηση MARK, παρακαλώ ξαναδοκιμάστε.");
                }
            }
        }
    }, [])

    useEffect(() => {
        if (updateTabSelection) {
            setUpdateTabSelection(false);
            updateTabSelectionFunction();
        }
    }, [updateTabSelection])

    useEffect(() => {
        if (isEpay || isCardlink) {
            dispatch(openPrimerPaymentsReport(TABS_DATA));
            const startOpen = TABS_DATA.some((item) => item.tabType === "start");
            if (startOpen) dispatch(removeTab("start"));
        }
        if (isEmployee) {
            dispatch(openEmployeeView(TABS_DATA));
            const startOpen = TABS_DATA.some((item) => item.tabType === "start");
            if (startOpen) dispatch(removeTab("start"));
        }
        if (isOnlyCloud) {
            dispatch(openCloud(TABS_DATA));
            const startOpen = TABS_DATA.some((item) => item.tabType === "start");
            if (startOpen) dispatch(removeTab("start"));
        }
        if (isPrimerConstructor) {
            dispatch(openPrimerProviderContractsReport(TABS_DATA));
            const startOpen = TABS_DATA.some((item) => item.tabType === "start");
            if (startOpen) dispatch(removeTab("start"));
        }

        // Forget inner tab selection when closing tab
        const deleteKeys = [];
        for (const tabKey in rememberInnerTab) {
            if (!TABS_DATA.some((el) => el.key === tabKey)) {
                deleteKeys.push(tabKey);
            }
        }
        if (deleteKeys.length > 0) {
            let cloneRememberInnerTabs = structuredClone(rememberInnerTab);
            for (let key of deleteKeys) {
                delete cloneRememberInnerTabs[key];
            }
            dispatch(setRememberInnerTabsForce(cloneRememberInnerTabs));
        }
    }, [TABS_DATA])

    useEffect(() => {
        if (isInCloudTab) dispatch(activePath(""));
    }, [isInCloudTab])

    const updateTabSelectionFunction = () => {
        if (TABS_DATA.length > 0) {
            const ids = TABS_DATA.map(obj => obj.incrementalId);
            const maxIndex = ids.indexOf(Math.max(...ids));
            dispatch(updateActiveMainTab(maxIndex));
        } else {
            dispatch(updateActiveMainTab(0));
        }
    }

    const performTabRemoval = (tab) => {
        dispatch(removeTab(tab));
        setUpdateTabSelection(true);

        const tabType = tab.tabType;
        if (tabType === "products-search") {
            dispatch(setSearchProducts([]));
            dispatch(resetFilters("Search Products"));
        } else if (tabType === "pricelist-search") {
            dispatch(setSearchProductPriceList([]));
            dispatch(resetFilters("Search Product Price List"));
        } else if (tabType === "product-movements-search") {
            dispatch(setSearchProductMovements([]));
            dispatch(resetFilters("Search Product Movements"));
        } else if (tabType === "sales-search") {
            dispatch(setSearchSales([]));
            dispatch(resetFilters("Sales Search"));
        } else if (tabType === "sales-quotations-search") {
            dispatch(setSearchQuotations([]));
            dispatch(resetFilters("Quotations Search"));
        } else if (tabType === "search-client-payments") {
            dispatch(setClientPaymentsSearch([]));
            dispatch(resetFilters("Client Payments Search"));
        } else if (tabType === "buys-search") {
            dispatch(setSearchBuys([]));
            dispatch(resetFilters("Buys Search"));
        } else if (tabType === "search-supplier-payments") {
            dispatch(setSupplierPaymentsSearch([]));
            dispatch(resetFilters("Supplier Payments Search"));
        } else if (tabType === "search-client") {
            dispatch(setSearchClients([]));
            dispatch(resetFilters("Client Search"));
        } else if (tabType === "search-client-movements") {
            dispatch(setSearchClientMovements([]));
            dispatch(resetFilters("Client Movements Search"));
        } else if (tabType === "search-supplier") {
            dispatch(setSearchSuppliers([]));
            dispatch(resetFilters("Supplier Search"));
        } else if (tabType === "search-supplier-movements") {
            dispatch(setSearchSupplierMovements([]));
            dispatch(resetFilters("Supplier Movements Search"));
        } else if (tabType === "basic-types-search") {
            dispatch(setSearchBasicTypes([]));
            dispatch(resetFilters("Basic Types Search"));
        } else if (tabType === "advanced-types-search") {
            dispatch(setSearchAdvancedTypes([]));
            dispatch(resetFilters("Advanced Types Search"));
        } else if (tabType === "accounting-account-search") {
            dispatch(setSearchAccountingAccounts([]));
            dispatch(resetFilters("Accounting Account Search"));
        } else if (tabType === "accounting-record-search") {
            dispatch(setSearchAccountingRecords([]));
            dispatch(resetFilters("Accounting Record Search"));
        } else if (tabType === "working-program-employee") {
            dispatch(setWorkingProgramOnEmployee(null));
        } else if (tabType === "search-fixed-assets") {
            dispatch(setSearchFixedAssets([]));
            dispatch(resetFilters("Fixed Assets Search"));
        } else if (tabType === "search-fixed-asset-movements") {
            dispatch(setSearchFixedAssetMovements([]));
            dispatch(resetFilters("Fixed Asset Movements Search"));
        } else if (tabType === "search-fixed-asset-records") {
            dispatch(setSearchFixedAssetRecords([]));
            dispatch(resetFilters("Fixed Asset Records Search"));
        } else if (tabType === 'products-new') {
            dispatch(resetSelectedProduct())
            dispatch(setSaveNewProduct(false));
        } else if (tabType === 'product-movements-new') {
            dispatch(resetNewProductMovements())
            dispatch(resetProductMovementsNewProduct());
            dispatch(setSaveNewProductMovements(false));
        } else if (tabType === 'product-pricelist-new') {
            dispatch(resetNewPriceList())
            dispatch(setSaveNewPriceList(false));
        } else if (tabType === 'new-client') {
            dispatch(setNewClient(newClientInitialValue))
            dispatch(setSaveNewClient(false));
        } else if (tabType === 'new-employee') {
            dispatch(setNewEmployee(newEmployeeInitialValue))
            dispatch(setSaveNewEmployee(false));
        } else if (tabType === 'accounting-account-new') {
            dispatch(resetNewAccountingAccount())
            dispatch(setSaveNewAccountingAccount(false));
        } else if (tabType === 'accounting-record-new') {
            dispatch(resetNewAccountingRecord());
            dispatch(setSaveNewAccountingRecord(false));
        } else if (tabType === 'new-client-movements') {
            dispatch(setNewClientMovements(clientMovementsInitialValues))
            dispatch(setSaveNewClientMovements(false));
        } else if (tabType === 'cash-registers-new') {
            dispatch(setNewCashRegisters(newCashRegistersInitialValue))
            dispatch(setSaveNewCashRegister(false));
        } else if (tabType === 'new-bank-account') {
            dispatch(setNewBankAccount(newBankAccountInitialValue))
            dispatch(setSaveNewBankAccounts(false));
        } else if (tabType === 'new-pos') {
            dispatch(setNewPOS(newPOSInitialValue))
            dispatch(setSaveNewPOS(false));
        } else if (tabType === 'basic-types-new') {
            dispatch(clearNewBasicType())
            dispatch(setSaveBasicType(false));
        } else if (tabType === 'advanced-types-new') {
            dispatch(clearNewAdvancedType())
            dispatch(setSaveAdvancedType(false));
        } else if (tabType === 'sales-new') {
            dispatch(setShowDclAfterSaleNew(false));
            dispatch(setShowDclPageAfterSaleNew(false));
            dispatch(resetNewSales())
            dispatch(setSaveSales(false));
        } else if (tabType === 'sales-quotations-new') {
            dispatch(resetNewQuotations());
            dispatch(setSaveQuotations(false));
        } else if (tabType === 'sales-quotations-edit') {
            dispatch(setSaveEditQuotations(false));
        } else if (tabType === 'primer-ai-url') {
            dispatch(setSavePrimerAiUrl(false));
            dispatch(resetNewPrimerAiUrl());
        } else if (tabType === 'buys-new') {
            dispatch(resetNewBuys());
            dispatch(setSaveBuys(false));
        } else if (tabType === 'new-client-payments') {
            dispatch(resetNewClientPayment());
            dispatch(setSaveClientPayments(false));
        } else if (tabType === 'new-supplier-payments') {
            dispatch(setSaveSupplierPayments(false));
        } else if (tabType === "new-fixed-asset") {
            dispatch(resetNewFixedAsset());
            dispatch(setSaveNewFixedAsset(false));
        } else if (tabType === "new-fixed-asset-movement") {
            dispatch(resetNewFixedAssetMovement());
            dispatch(setSaveNewFixedAssetMovement(false));
        } else if (tabType === "new-fixed-asset-record") {
            dispatch(resetNewFixedAssetRecord());
            dispatch(setSaveNewFixedAssetRecord(false));
        }
    }

    const handleTabRemove = (tab) => {
        if (CHECK_FOR_ACTIVITY.includes(tab.tabType) && tab.activity) {
            showTabCloseWarning(true);
            setToRemoveTab(tab);
        } else {
            performTabRemoval(tab);
        }
    }

    const tabCloseConfirm = () => {
        showTabCloseWarning(false);
        performTabRemoval(toRemoveTab);
    }

    const handleDragStart = (e, index) => {
        setDraggedTabIndex(index);
    }

    const handleDragOver = (e) => {
        e.preventDefault();
    }

    const handleDragEnter = (e, index) => {
        e.preventDefault();
        if (draggedTabIndex < index) e.target.closest("li").classList.add("tab-dragover-right");
        else if (draggedTabIndex > index) e.target.closest("li").classList.add("tab-dragover-left");
    }

    const handleDragLeave = (e, index) => {
        e.preventDefault();
        if (draggedTabIndex !== index) {
            e.target.closest("li").classList.remove("tab-dragover-right");
            e.target.closest("li").classList.remove("tab-dragover-left");
        }
    }

    const handleDrop = (e, dropIndex) => {
        e.preventDefault();
        e.target.closest("li").classList.remove("tab-dragover-right");
        e.target.closest("li").classList.remove("tab-dragover-left");

        if (draggedTabIndex === null || draggedTabIndex === dropIndex) return;

        if (ACTIVE_MAIN_TAB_SLICE > draggedTabIndex && ACTIVE_MAIN_TAB_SLICE <= dropIndex) dispatch(updateActiveMainTab(ACTIVE_MAIN_TAB_SLICE - 1));
        else if (ACTIVE_MAIN_TAB_SLICE < draggedTabIndex && ACTIVE_MAIN_TAB_SLICE >= dropIndex) dispatch(updateActiveMainTab(ACTIVE_MAIN_TAB_SLICE + 1));
        else if (ACTIVE_MAIN_TAB_SLICE === draggedTabIndex) dispatch(updateActiveMainTab(dropIndex));
        dispatch(reOrderTabs([draggedTabIndex, dropIndex]));
        setDraggedTabIndex(null);
    }

    const onSelect = (index) => {
        if (TABS_DATA[index].key && TABS_DATA[index].key === TABS_DATA[ACTIVE_MAIN_TAB_SLICE]?.key) return; // Prevent same tab re-rendering on re-pressing
        if (TABS_DATA.some((el) => el.tabType === "working-program-employee")) {
            if (TABS_DATA[index].tabType !== "working-program-employee") toast.info("Παρακαλώ τελειώστε πρώτα με την επεξεργασία προγράμματος του εργαζομένου.");
            return; // Prevent user from changing tabs when in working-program-employee
        }
        dispatch(tabIncremental(index));
        dispatch(updateActiveMainTab(index));
    }

    useEffect(() => {
        if (activeTab) {
            const el = containerRefs.current[activeTab.key];
            requestAnimationFrame(() => {
                if (el && activeTab?.scrollPosition >= 0) el.scrollTop = activeTab.scrollPosition;
            });
        }
    }, [ACTIVE_MAIN_TAB_SLICE]);

    useEffect(() => {
        if (TABS_DATA.length === 0 && !isEpay && !isEmployee && !isCardlink && !isOnlyCloud && !isPrimerConstructor) {
            dispatch(openStart(TABS_DATA));
            dispatch(updateActiveMainTab(0));
        } else if (ACTIVE_MAIN_TAB_SLICE >= TABS_DATA.length && !updateTabSelection) {
            dispatch(updateActiveMainTab(TABS_DATA.length - 1));
        }
    }, [TABS_DATA]);

    const handleInteraction = useCallback((tab) => {
        if (CHECK_FOR_ACTIVITY.includes(tab.tabType) && !tab.activity) {
            dispatch(tabActivity({ key: tab.key }));
        }
    }, [])

    return (
        <React.Fragment>
            {TABS_DATA.length > 0 && (
                <Tabs
                    selectedIndex={ACTIVE_MAIN_TAB_SLICE}
                    onSelect={(index) => {
                        if (index !== ACTIVE_MAIN_TAB_SLICE) {
                            const currentTab = TABS_DATA[ACTIVE_MAIN_TAB_SLICE];
                            const currentRef = containerRefs.current[currentTab?.key];
                            if (currentRef) dispatch(tabScrollPosition({key: currentTab.key, scrollPosition: currentRef.scrollTop}));
                        }
                        onSelect(index);
                    }}
                >
                    <div className="d-flex main-tabs no-print" style={{
                        left: slideBarToggle ? "70px" : "",
                        width: isMobileScreen ? "100%" : slideBarToggle ? "calc(100% - 80px)" : "calc(100% - 260px)",
                        transition: "all 0.25s ease", top: "25px",
                    }}>
                        <TabList className="react-tabs__tab-list tab-style main-tab-list" style={{pointerEvents: isEmronConnectFileERP ? "none" : ""}}>
                            <React.Fragment>
                                {TABS_DATA.map((tab, i) => (
                                    <Tab
                                        draggable
                                        onDragStart={(e) => handleDragStart(e, i)}
                                        onDragOver={(e) => handleDragOver(e)}
                                        onDragEnter={(e) => handleDragEnter(e, i)}
                                        onDragLeave={(e) => handleDragLeave(e, i)}
                                        onDrop={(e) => handleDrop(e, i)}
                                        title={t('TabsText.' + tab.tabType)}
                                        className={`react-tabs__tab maxWidthLimit tab-${tab.tabType}-${i}`}
                                        onMouseDown={(e) => {
                                            if (e.button === 1 && tab.tabType !== "start") {
                                                e.stopPropagation();
                                                handleTabRemove(tab, i);
                                            }
                                        }}
                                        key={tab?.key || i}>
                                            <div
                                                style={{display: "flex", alignItems: "center", width: "100%", height: "100%", overflow: "hidden", whiteSpace: "nowrap"}}>
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleTabRemove(tab, i);
                                                }}
                                                type="button" className="tab-close-btn" hidden={tab.tabType === "start"}>
                                                <i className="mdi mdi-close"></i>
                                            </button>
                                            {tab?.displayName ? (
                                                <span>{tab.displayName}</span>
                                            ) : (
                                                <span style={{textOverflow: 'ellipsis'}} className="tabText">{t('TabsText.' + tab.tabType)}</span>
                                            )}
                                        </div>
                                    </Tab>
                                ))}
                            </React.Fragment>
                        </TabList>
                    </div>

                    {/* Tab Panel containing data for the specific tab to render in the view */}
                    {/* Rendering the table tabs data  */}
                    {TABS_DATA.map((tab, idx) => (
                        // the following function creates the view according to the tab opened in the view wrapper of the application
                        <TabPanel key={tab?.key || idx}>
                            <div id="tab-content"
                                 ref={(el) => {
                                     if (el) containerRefs.current[tab.key] = el;
                                 }}
                                 style={{ overflowY: "auto", height: 'calc(100vh - 175px)', overflowX: "hidden", paddingRight: "10px", transition: "all 0.25s ease"}}
                                 className={"tab-content-style"}
                                 onFocus={() => handleInteraction(tab)}
                            >
                                {idx === ACTIVE_MAIN_TAB_SLICE && checkViewFunc(tab)}
                            </div>
                        </TabPanel>
                    ))}
                </Tabs>
            )}

            {/* Confirm Close Tabs */}
            <Modal backdrop={"static"} className="themeModal" show={tabCloseWarning}>
                <Modal.Header>
                    <Modal.Title>{t('ClosingTabWarning.warning')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{t('ClosingTabWarning.message')}</Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => showTabCloseWarning(false)}>{t('ClosingTabWarning.no')}</Button>
                    <Button variant="primary" onClick={() => tabCloseConfirm()}>{t('ClosingTabWarning.yes')}</Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default TabsLayout;
